/* Freddo Holiday Decor v1.0 — decora la cabecera segun window.FreddoHoliday (lo escribe snippets/freddo-holiday.liquid).
   Vista previa: ?holiday=<clave> (se recuerda en la pestana), ?holiday=none (sin decoracion), ?holiday=off (volver a lo real).
   Procedimiento: Wiki\procedimientos\shopify\decoracion-festivos-freddo.md */
(function () {
  'use strict';
  var cfg = window.FreddoHoliday || {};
  var BASE = (cfg.js || '').replace(/fh\.js(\?.*)?$/, '');
  var q = null;
  try { q = new URLSearchParams(location.search).get('holiday'); } catch (e) {}
  try {
    if (q === 'off') { sessionStorage.removeItem('fh_preview'); q = null; }
    else if (q) { sessionStorage.setItem('fh_preview', q); }
    else { q = sessionStorage.getItem('fh_preview'); }
  } catch (e) {}

  function $(s, r) { return (r || document).querySelector(s); }
  function el(tag, cls) { var e = document.createElement(tag); if (cls) e.className = cls; return e; }
  function rnd(a, b) { return a + Math.random() * (b - a); }

  function undecorate() {
    var l = $('#fh-css'); if (l) l.remove();
    ['.fh-topper', '.fh-sky', '.fh-greet', '.fh-hat'].forEach(function (s) { document.querySelectorAll(s).forEach(function (n) { n.remove(); }); });
    document.body.className = document.body.className.replace(/\bfh(-[\w-]+)?\b/g, '').replace(/\s+/g, ' ').trim();
  }

  function loadCss(pack) {
    return new Promise(function (res, rej) {
      var old = $('#fh-css');
      var l = el('link'); l.rel = 'stylesheet'; l.id = 'fh-css'; l.href = BASE + 'fh-' + pack + '.css';
      l.onload = function () { if (old && old !== l) old.remove(); res(); };
      l.onerror = function () { l.remove(); rej(new Error('no existe el pack ' + pack)); };
      document.head.appendChild(l);
    });
  }

  function greet(text) {
    if (!text) return;
    var host = $('.announcement-bar__text'); // icono + texto del primer anuncio
    if (!host) { var rte = $('.announcement-bar__rte'); if (!rte) return; host = rte.querySelector('p') || rte; }
    var s = el('span', 'fh-greet'); s.textContent = text;
    host.insertBefore(s, host.firstChild);
  }

  function topper() {
    if ($('.fh-topper')) return;
    var t = el('div', 'fh-topper'); t.setAttribute('aria-hidden', 'true');
    document.body.insertBefore(t, document.body.firstChild);
  }

  function sky() { // particulas cayendo por toda la ventana (capa fija, no tapa nada: pointer-events none)
    var cs = getComputedStyle(document.body);
    var n = parseInt(cs.getPropertyValue('--fh-particles'), 10) || 0;
    var size = parseInt(cs.getPropertyValue('--fh-p-size'), 10) || 16;
    if (!n || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.innerWidth < 750) n = Math.ceil(n / 2);
    var s = el('div', 'fh-sky'); s.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < n; i++) {
      var p = el('span', 'fh-p fh-p' + (1 + (i % 3)));
      var d = rnd(12, 24);
      p.style.left = rnd(1, 98) + '%';
      p.style.setProperty('--s', Math.round(size * rnd(0.7, 1.25)) + 'px');
      p.style.setProperty('--d', d.toFixed(1) + 's');
      p.style.setProperty('--delay', (-rnd(0, d)).toFixed(1) + 's');
      p.style.setProperty('--x', Math.round(rnd(-60, 60)) + 'px');
      p.style.setProperty('--r', Math.round(rnd(-220, 220)) + 'deg');
      s.appendChild(p);
    }
    document.body.appendChild(s);
  }

  // Sombrero sobre la "F" del logo 3D (3D.png): la F ocupa x 17-30 % del ancho de la imagen y su borde superior esta al 11 % de la altura.
  var F_CX = 0.237, F_TOP = 0.112;
  function hat() {
    var cs = getComputedStyle(document.body);
    var w = parseFloat(cs.getPropertyValue('--fh-hat-w')) || 0; if (!w) return;
    var sit = parseFloat(cs.getPropertyValue('--fh-hat-sit')) || 0.9;
    var dx = parseFloat(cs.getPropertyValue('--fh-hat-dx')) || 0, dy = parseFloat(cs.getPropertyValue('--fh-hat-dy')) || 0;
    var anchors = document.querySelectorAll('.header__logo');
    function place() {
      anchors.forEach(function (a) {
        var img = a.querySelector('img'); if (!img) return;
        var h = a.querySelector('.fh-hat'); if (!h) { h = el('span', 'fh-hat'); h.setAttribute('aria-hidden', 'true'); a.appendChild(h); }
        var ar = a.getBoundingClientRect(), ir = img.getBoundingClientRect();
        if (!ir.width) { h.style.display = 'none'; return; }
        var hw = ir.width * w, hh = hw * 56 / 64;
        h.style.display = 'block'; h.style.width = hw + 'px';
        h.style.left = (ir.left - ar.left + ir.width * (F_CX + dx) - hw / 2) + 'px';
        h.style.top = (ir.top - ar.top + ir.height * (F_TOP + dy) - hh * sit) + 'px';
      });
    }
    anchors.forEach(function (a) { var img = a.querySelector('img'); if (img && !img.complete) img.addEventListener('load', place); });
    place();
    var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(place, 150); });
  }

  function decorate(pack, level, greeting) {
    document.body.classList.add('fh', 'fh-' + pack, 'fh-' + (level || 'light'));
    greet(greeting);
    if (level === 'full') { topper(); hat(); sky(); }
  }

  function pickLang(obj) { if (!obj) return ''; return obj[cfg.lang] || obj.en || ''; }

  function meta(key) { // nombre/saludo/nivel de un festivo desde el Worker (solo para vista previa u override de otra clave)
    return fetch(cfg.worker + '/holiday?store=' + encodeURIComponent(cfg.store) + '&key=' + encodeURIComponent(key))
      .then(function (r) { if (!r.ok) throw new Error('festivo desconocido: ' + key); return r.json(); });
  }

  function run() {
    if (q === 'none') { undecorate(); return; }
    if (q && q !== cfg.key) { // vista previa de otro festivo
      undecorate();
      meta(q).then(function (m) { return loadCss(m.pack).then(function () { decorate(m.pack, m.level, pickLang(m.greeting)); }); })
        .catch(function (e) { console.warn('[FreddoHoliday] vista previa:', e.message); });
      return;
    }
    if (!cfg.key) return;
    if (cfg.fetchMeta) { // override manual de un festivo distinto al calculado: faltan nivel y saludo
      meta(cfg.key).then(function (m) {
        var p = m.pack === cfg.pack ? Promise.resolve() : loadCss(m.pack);
        return p.then(function () { decorate(m.pack, m.level, pickLang(m.greeting)); });
      }).catch(function (e) { console.warn('[FreddoHoliday]', e.message); decorate(cfg.pack, 'light', ''); });
      return;
    }
    decorate(cfg.pack, cfg.level, cfg.greeting);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
